/*
  お客様あてのメールの同意の欄 (PR M1b)。画面の外に出せる決まりだけを置く。

  - 同意の欄は任意で、最初はチェックなし。チェックしなければ何も記録せず、お手続きのメール
    (予約の受付や振込の案内) は今までどおり届く
  - 同意の欄はログイン中の本人の画面 (体験の登録) にだけ置く。予約や支払いのフォームは、入力された
    住所の持ち主を確かめていないので置かない (他人の住所で同意を作れてしまうため)
  - 文言を変えたら版を上げる。api-go の domain/messaging の ConsentTextVersion と同じ値にそろえる。
    api-go は知らない版の同意を受けない
*/

export const MAIL_CONSENT_TEXT_VERSION = "marketing-v1";

/** チェックの文言。版 marketing-v1 の本文そのもの */
export const MAIL_CONSENT_LABEL = "ゆめさくからのお知らせ（学びのヒントや募集のご案内）をメールで受け取る";

/** 欄の下に添える説明 */
export const MAIL_CONSENT_NOTE =
  "任意です。チェックしなくても、ご予約やお支払いなどのお手続きのメールは届きます。メールの末尾のリンクから、いつでも止められます。";

/** 同意を残したフォームの名前。api-go の ValidConsentSource と同じ。ログイン中の本人の画面だけ */
export type MailConsentSource = "trial";
